import { useSelector } from "react-redux";
import { selectWorldCupResult } from "./WorldCupResultSlice";
import { Box, FormControlLabel, Grid, IconButton, Paper, Skeleton, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import TeamItem from "./TeamItem";
import MatchTable from "./MatchTable";
import { useState } from "react";
import { intArray } from "./utils";
import { selectTeam } from "./TeamSlice";
import { SwapHoriz } from "@mui/icons-material";
import EditTeamDialog from "./EditTeamDialog";

export default function WorldCupGroupStage() {
    const result = useSelector(selectWorldCupResult);
    const teams = useSelector(selectTeam);
    const [showFullTables, setShowFullTables] = useState(false);
    const [open, setOpen] = useState(false);
    const [dialogData, setDialogData] = useState({});
    let groupSize;
    if (result.year <= 1994) {
        groupSize = 6;
    } else if (result.year <= 2022) {
        groupSize = 8;
    } else {
        groupSize = 12;
    }
    return <Box>
        <EditTeamDialog open={open} setOpen={setOpen} dialogData={dialogData} setDialogData={setDialogData} />
        <FormControlLabel
            control={<Switch
                checked={showFullTables}
                onChange={e => setShowFullTables(e.target.checked)}
            />}
            label="Show full tables"
        />
        <Grid container spacing={2}>
            {intArray(groupSize).map(i =>
                <Grid
                    item
                    xs={12}
                    md={showFullTables ? 12 : 6}
                    lg={showFullTables ? 12 : 3}
                    key={i}
                >
                    <Typography margin="8px" fontSize="1.2em" fontWeight="bold" variant="h3">
                        {"Group " + String.fromCharCode(65 + i)}
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={showFullTables ? 6 : 12}
                            lg={showFullTables ? 6 : 12}
                        >
                            <TableContainer component={Paper}>
                                <Table padding="none">
                                    <TableHead>
                                        <TableRow sx={{ height: 40, borderLeft: 4, borderLeftColor: "transparent" }}>
                                            <TableCell align="left" sx={{ paddingLeft: "4px" }}>Team</TableCell>
                                            {showFullTables && <TableCell align="center">W</TableCell>}
                                            {showFullTables && <TableCell align="center">D</TableCell>}
                                            {showFullTables && <TableCell align="center">L</TableCell>}
                                            {showFullTables && <TableCell align="center">GF</TableCell>}
                                            {showFullTables && <TableCell align="center">GA</TableCell>}
                                            {showFullTables && <TableCell align="center">GD</TableCell>}
                                            <TableCell align="center">Pts</TableCell>
                                            <TableCell />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {intArray(4).map(j => {
                                            let row, team, win, draw, lose, goalFor, goalAgainst, goalDiff, points;
                                            if (result.groupTables && result.groupTables[i]) {
                                                row = result.groupTables[i][j];
                                                team = <TeamItem code={row.code} />;
                                                win = row.win;
                                                draw = row.draw;
                                                lose = row.lose;
                                                goalFor = row.goalFor;
                                                goalAgainst = row.goalAgainst;
                                                goalDiff = goalFor - goalAgainst;
                                                points = row.points;
                                            } else if (result.loading || teams.loading) {
                                                team = <Skeleton animation={false} />;
                                                win = <Skeleton animation={false} />;
                                                draw = <Skeleton animation={false} />;
                                                lose = <Skeleton animation={false} />;
                                                goalFor = <Skeleton animation={false} />;
                                                goalAgainst = <Skeleton animation={false} />;
                                                goalDiff = <Skeleton animation={false} />;
                                                points = <Skeleton animation={false} />;
                                            }
                                            return <TableRow
                                                key={j}
                                                sx={{ borderLeft: 4, borderLeftColor: row?.qualified ? "success.main" : "transparent" }}
                                            >
                                                <TableCell align="left">{team}</TableCell>
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{win}</TableCell>}
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{draw}</TableCell>}
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{lose}</TableCell>}
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{goalFor}</TableCell>}
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{goalAgainst}</TableCell>}
                                                {showFullTables && <TableCell align="center" sx={{ width: 24 }}>{goalDiff}</TableCell>}
                                                <TableCell align="center" sx={{ width: 24 }}>{points}</TableCell>
                                                <TableCell align="center" sx={{ width: 40 }}>
                                                    <IconButton
                                                        color="primary"
                                                        disabled={result.loading || teams.loading}
                                                        onClick={() => {
                                                            if (row && result.draw && result.draw[i] && result.ratings) {
                                                                setDialogData({ oldCode: row.code, newCode: row.code, rating: result.ratings[row.code] });
                                                                setOpen(true);
                                                            }
                                                        }}
                                                    >
                                                        <SwapHoriz />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>;
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        {showFullTables && <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                        >
                            <Grid container spacing={2}>
                                {intArray(6).map(j =>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        lg={6}
                                        key={j}
                                    >
                                        <MatchTable
                                            stage="G"
                                            groupIndex={i}
                                            matchIndex={j}
                                            key={j}
                                        />
                                    </Grid>)}
                            </Grid>
                        </Grid>}
                    </Grid>
                </Grid>)}
        </Grid>
    </Box>;
}